























































import { Component, Vue } from 'vue-property-decorator'
import Arrows from '@/components/Arrows.vue'

type Tier = {
  name: string
  price: number | null
  description?: string
  features: string[]
  buttonText: string
  to: {
    name: string
    params: {
      [key: string]: string
    }
  }
}

@Component({
  metaInfo: {
    title: "Pricing",
  },
  components: {
    Arrows
  }
})
export default class Pricing extends Vue {
  
  annual = true
  get pricingTiers(): Tier[] {
    return [
      {
        price: 0,
        name: 'free',
        description: 'Free forever',
        features: [
          'Up to 5 contractors',
          'Ticket-based support',
        ],
        buttonText: 'Get free',
        to: {
          name: 'signUp',
          params: {
            subscriptionTier: `FREE`, 
          }
        }
      },
      {
        price: this.annual ? 16 : 20,
        name: 'standard',
        features: [
          'Up to 10 contractors',
          'Multiple managers per organization',
          'Chat-based support representative',
        ],
        buttonText: 'Get standard',
        to: {
          name: 'signUp',
          params: {
            subscriptionTier: `STANDARD_${this.annual ? 'ANNUALLY' : 'MONTHLY'}`
          }
        }
      },
      {
        price: null,
        name: 'enterprise',
        description: 'Speak with sales',
        features: [
          'Unlimited contractors',
          'Dedicated account manager',
        ],
        buttonText: 'Contact sales',
        to: {name: 'contact', params: { option: 'sales' }}
      }
    ]
  }

  highlight(tier: Tier) {
    return tier.name == 'standard'
  }
}
